
define('app/dashboard/leagues/instances/views/lgPositionDelView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/leagueUserModel',
	'known/models/leaguePositionModel',
	'known/models/productTypeModel'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		LeagueUserModel,
		LeaguePositionModel,
		ProductTypeModel){


	var RemovePositionFooterView = Backbone.View.extend({
		initialize: function(options) {
			this.event = options.event;
			
			this.showDeleteForm();
			
			this.listenTo(this.event, 'default', this.showDeleteForm);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showDeleteForm);
			this.listenTo(this.event, 'success', this.showDeleteForm);
			
			_.bindAll(this, 'submitDeleteForm');
			
			$(this.el).find(".removePosFormSubmit").on('click', this.submitDeleteForm);
		},
		
		hideAll: function () {
			this.$(".removePosFormSubmit").hide();
			this.$(".removePosFormCancel").hide();
		},
		
		submitDeleteForm: function () {
			this.event.trigger("save");
		},
		
		showDeleteForm: function () {
			this.hideAll();
			
			this.$(".removePosFormCancel").show();
			this.$(".removePosFormSubmit").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var RemovePositionContentView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			this.submittedData = options.submittedData;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.position = options.position;
			this.prodType = options.prodType;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			this.listenTo(this.event, 'save', this.deletePosition);
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.removePositionForm);
			this.listenTo(this.event, 'success', this.removePositionForm);
		},
		
		deletePosition: function(event) {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;				
				this.position.destroy({success: this.successCallback, error: this.errorCallback, wait: true});
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		hideAll: function() {
			$(this.el).hide();
		},
		
		removePositionForm: function () {
			this.hideAll();
			$(this.el).show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var RemovePositionMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'resetMessages', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.remSuccess);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$(".removePosBodyMessageError").hide();
			this.$(".removePosBodyMessageProcessing").hide();
			this.$(".removePosBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".removePosBodyMessageError").show();
		},
		
		remSuccess: function () {
			this.hideAll();
			//$(this.el).show();
			//this.$(".removePosBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".removePosBodyMessageProcessing").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var RemovePositionView = Backbone.View.extend({
		initialize: function(options) {		
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.position = options.position;
			this.prodType = options.prodType;
			this.prodConfig = options.prodConfig;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'hideView');
			_.bindAll(this, 'showView');
			
			this.message = new RemovePositionMessageView({el: this.$(".removePosBodyMessage"), event: this.event});
			this.content = new RemovePositionContentView({
					el: this.$(".removePosBodyContent"), 
					event: this.event,
					submittedData : this.submittedData,
					userModel: this.userModel, 
					lgInstance: this.lgInstance,
					position: this.position,
					prodType: this.prodType});
			this.footer = new RemovePositionFooterView({
				el: this.$(".removePosFooter"), 
				event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.success);
			this.listenTo(this.event, 'savingError', this.error);
			
			//this.listenTo(this.lgInstance, 'change:draftStatus', this.updateVisuals);
			
			//Setup Form open/hide
			var remPosOpenBtn = this.$(".removePosOpen");
			var remPosCloseBtn = this.$(".removePosFormCancel");
			
			remPosOpenBtn.on('click', {}, this.showView);
			remPosCloseBtn.on('click', {}, this.hideView);
		},
		
		render: function () {
			this.event.trigger("default");
			this.updateVisuals();
			return this;
		},
		
		updateVisuals: function() {
			//Determine whether to show the Remove Team form button
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.prodConfig.CUSTPOS == 'true'
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				this.$(".removePosOpen").show();
			} else {
				this.$(".removePosOpen").hide();
			}
		},
		
		hideView: function() {
			this.event.trigger("resetMessages");
			this.$(".removePosOpen").show();
			this.$(".editPosOpen").show();
			this.$(".removePosBodyContent").slideUp();
		},
		
		showView: function() {
			this.$(".removePosOpen").hide();
			this.$(".editPosOpen").hide();
			this.$(".removePosBodyContent").slideDown();
		},
		
		error: function(model, error) {
			if(this.submittedData.isSubmitted){
				this.position.destroy();
				
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		success: function () {			
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			}

			this.$(".removePosOpen").show();
			this.$(".editPosOpen").show();
			this.$(".removePosBodyContent").hide();
		},
	    
	    destroyView: function() {
	    	this.message.destroyView();
			this.content.destroyView();
			this.footer.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	return RemovePositionView;  
});